import styled from 'styled-components'
import { backgroundOrange, darkOrange, textMuted, warmTint, white } from '@/theme/colors'
import { fontDisplay } from '@/theme/fonts'
import { flatButton } from '@/theme/recipes'
import { motion, radii, shadows } from '@/theme/tokens'
import { fontSizes } from '@/theme/typography'

/**
 * The segmented control's bar: white, on the control radius, holding two to
 * four mutually exclusive options. Use it for mode toggles (Auto / Manual,
 * Equal / Percent / Value, Balances / Activity) — not for navigation.
 */
export const SegmentedBar = styled.div`
	display: flex;
	gap: 4px;
	padding: 4px;
	background: ${white};
	border: 1px solid ${warmTint};
	border-radius: ${radii.inner};
`

/** One option: quiet text until selected, when it takes the warm ground and a hairline ring. */
export const SegmentedOption = styled.button<{ $selected: boolean }>`
	${flatButton}
	flex: 1;
	padding: 7px 12px;
	border-radius: ${radii.small};
	font-family: ${fontDisplay};
	font-weight: 700;
	font-size: ${fontSizes.caption};
	white-space: nowrap;
	color: ${({ $selected }) => ($selected ? darkOrange : textMuted)};
	background: ${({ $selected }) => ($selected ? backgroundOrange : 'transparent')};
	box-shadow: ${({ $selected }) => ($selected ? shadows.ring : 'none')};
	transition:
		background-color ${motion.fast},
		color ${motion.fast};

	&:hover:not(:disabled) {
		color: ${darkOrange};
	}
`
